<template>
  <div class="d-flex flex-column min-vh-100">
    <PriorHeader />

    <v-container class="flex-grow-1 d-flex">
      <v-row justify="center" class="w-100">
        <v-col cols="12" sm="10" md="8" lg="6">
          <div class="text-center mb-12 mt-16">
            <h1 class="text-primary weight-600">Reset Password</h1>
          </div>

          <v-card class="pa-6">
            <v-card-text>
              <div v-if="!passwordRequestEmailSent">
                <v-form @submit.prevent="passwordSending">
                  <p class="text-center mb-4 text-primary weight-500">
                    Forgot your password? No problem! Enter your registered email address below, and we'll send you a
                    link to reset your password.
                  </p>

                  <v-text-field
                    v-model="userEmail"
                    label="Email Address"
                    type="email"
                    placeholder="example@findsunrise.com"
                    :error-messages="!isEmailValid && formButtonClicked ? 'Please enter a valid email address' : ''"
                    class="mb-4 lh--force-white-background" />

                  <v-btn color="primary" block size="large" type="submit" class="mb-4" :loading="showPreloader">
                    Get Password Reset Link
                  </v-btn>

                  <v-alert v-if="errors.length > 0" type="error" variant="tonal" class="mb-4">
                    <div v-for="error in errors" :key="error">{{ error }}</div>
                  </v-alert>

                  <div class="text-center mt-6">
                    <router-link :to="{ name: 'login' }" class="text-decoration-none text-primary weight-500">
                      Back to Login
                    </router-link>
                  </div>
                </v-form>
              </div>

              <div v-else class="text-center">
                <div class="mb-6">
                  <v-icon size="64" color="primary">mdi-email-check</v-icon>
                </div>
                <p class="text-primary weight-500">Check your email, you will receive a link to reset your password.</p>
                <div class="mt-6">
                  <router-link :to="{ name: 'login' }" class="text-decoration-none text-primary weight-500">
                    Back to Login
                  </router-link>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <PriorFooter />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import PriorHeader from "@/components/PriorHeader";
import PriorFooter from "@/components/PriorFooter";
import authService from "@/services/authService";
import { tryParseApiErrors } from "@/utils";
import { FORM_VALIDATION_PATTERNS } from "@/utils/constants";

const errors = ref([]);
const showPreloader = ref(false);
const passwordRequestEmailSent = ref(false);
const userEmail = ref("");
const formButtonClicked = ref(false);

// Validators
const isEmailValid = computed(() => {
  const email = userEmail.value;
  return email !== "" && FORM_VALIDATION_PATTERNS.EMAIL_PATTERN.test(email);
});

const passwordSending = async () => {
  formButtonClicked.value = true;

  if (isEmailValid.value) {
    showPreloader.value = true;
    try {
      await authService.passwordResetRequest(userEmail.value);
      passwordRequestEmailSent.value = true;
      userEmail.value = "";
      errors.value = [];
    } catch (error) {
      errors.value = tryParseApiErrors(error);
    } finally {
      showPreloader.value = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/main.scss";
</style>
